export const environment = {
    siteId: 1,
    name: 'babylon',
    apiBaseUrl: 'https://alcudiamar-api-dev.clicktotravel.es/api',
    baseUrl: 'https://alcudiamar-api-dev.clicktotravel.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: '34i!BGyAbGzvHp4N',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: true, // General switch for booking engine
    booking_engine_top_enabled: true, // Switch for booking engine button in top sliders
    booking_engine_extern: false,
    booking_button_engine_enabled: false, // Button booking engine
    openInNewWindow: false,
    trailingSlash: true,
    multipleMotorsModal: false,
    normalizeUrlsToLowercase: true,
    minSizeMobileHeader: 768,
};
